// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.gui_page-wrapper_XhImG {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.gui_body-wrapper_G5GJN {
    flex-grow: 1;
    background-color: var(--ui-primary);
}

.gui_body-wrapper_G5GJN * {
    box-sizing: border-box;
}

.gui_flex-wrapper_zZPgR {
    display: flex;

    /*
        Make 2 columns:
        a) for the blocks + workspace panes, and
        b) for combined stage menu + stage + sprite/stage selectors
    */
    /* flex-direction: row; Move to JSX */
    height: 100%;

    /*
        Stop scrollbar popping in and out from scratch-blocks border issue
        https://github.com/LLK/scratch-gui/issues/318
        TW: and also fix double horizontal scrollbar at some screen sizes in paint editor
    */
    overflow: hidden;
}

.gui_editor-wrapper_w4WEQ {
    /*
        This is carefully balanced--  the minimum width at which the GUI will be displayed is 1024px.
        At that size, the stage pane is 408px wide, with \$space of padding to each side.
        However, we must also add the border width to the stage pane. All-in-all, the stage pane's final width is
        408px + (\$space + \$stage-standard-border-width * 2) (one border & padding per left/right side).

        @todo This is in place to prevent "doubling up" of horizontal scrollbars in narrow windows, but there are likely
        much better ways to solve that (e.g. undo #2124, remove this flex-basis entirely). However, they run their own
        risks of breaking things, so let's just leave this as-is for the time being.
    */
    flex-basis: calc(1024px - 408px - ((0.5rem + 0.0625rem) * 2));
    flex-grow: 1;
    flex-shrink: 0;
    position: relative;
    background-color: var(--ui-white);

    display: flex;
    flex-direction: column;
}

.gui_editor-wrapper-full_xFN6I {
    flex-basis: auto !important;
    flex-grow: 1 !important;
    width: 100% !important;
}

.gui_tab-list_sIspJ {
    height: 2.75rem;
    width: 250px;
    /* Match width of the toolbox */
    display: flex;
    align-items: flex-end;
    flex-shrink: 0;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 0.80rem;

    /* Overrides for react-tabs styling */
    margin: 0 !important;
    border-bottom: 0 !important;

    color: var(--text-primary);
    background-color: var(--editorDarkMode-page, hsl(215, 100%, 95%));
    z-index: 25;
}

.gui_tab_QF0IR {
    flex-grow: 1;
    height: 80%;
    margin-bottom: 0;

    border-radius: 1rem 1rem 0 0;
    border: 1px solid var(--ui-black-transparent);

    padding: 0.125rem 1.25rem 0;
    font-size: 0.75rem;

    background-color: var(--ui-tertiary);
    color: var(--ui-text-primary-transparent);

    display: flex;
    justify-content: center;
    align-items: center;

    -webkit-user-select: none;

       -moz-user-select: none;

        -ms-user-select: none;

            user-select: none;
    white-space: nowrap;
}

[dir="ltr"] .gui_tab_QF0IR {
    margin-left: -0.5rem;
}

[dir="rtl"] .gui_tab_QF0IR {
    margin-right: -0.5rem;
}

[dir="ltr"] .gui_tab_QF0IR:nth-of-type(1) {
    margin-left: 0;
}

[dir="rtl"] .gui_tab_QF0IR:nth-of-type(1) {
    margin-right: 0;
}

/* Use z-indices to force left-on-top for tabs */

.gui_tab_QF0IR:nth-of-type(1) {
    z-index: 3;
}

.gui_tab_QF0IR:nth-of-type(2) {
    z-index: 2;
}

.gui_tab_QF0IR:nth-of-type(3) {
    z-index: 1;
}

.gui_tab_QF0IR:hover {
    background-color: var(--ui-primary);
}

.gui_tab_QF0IR.gui_is-selected_UFsl5 {
    height: 90%;
    color: var(--looks-secondary);
    background-color: var(--ui-white);
    z-index: 4;
    /* Make sure selected is always above */
}

.gui_tab_QF0IR img {
    width: 1rem;
    filter: grayscale(100%);
}

.gui_tab_QF0IR:hover img {
    filter: brightness(150%) grayscale(100%);
    -webkit-filter: brightness(150%) grayscale(100%);
}

[dir="ltr"] .gui_tab_QF0IR img {
    margin-right: 0.125rem;
}

[dir="rtl"] .gui_tab_QF0IR img {
    margin-left: 0.125rem;
}

/* mirror blocks and sound tab icons */

[dir="rtl"] .gui_tab_QF0IR:nth-of-type(1) img {
    transform: scaleX(-1);
}

[dir="rtl"] .gui_tab_QF0IR:nth-of-type(3) img {
    transform: scaleX(-1);
}

.gui_tab_QF0IR.gui_is-selected_UFsl5 img {
    filter: none;
}

/* Tab style overrides from react-tabs */

.gui_tab_QF0IR.gui_is-selected_UFsl5:after {
    display: none;
}

.gui_tab_QF0IR.gui_is-selected_UFsl5:focus {
    outline: none;
    box-shadow: none;
    border-color: var(--ui-black-transparent);
}

.gui_tab_QF0IR.gui_is-selected_UFsl5:focus:after {
    display: none;
}

/* Body of the tabs */

.gui_tabs_af7tX {
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.gui_vscode_PTgxj {
    flex-direction: column !important;
    height: 100% !important;
}

.gui_vscodeList_GM7MO {
    flex-direction: row !important;
}

.gui_tab-list_sIspJ.gui_vscode_PTgxj {
    width: 41px;
    flex-direction: column !important;
    align-items: center;
    justify-content: flex-start;
    border-bottom: none;
    overflow-y: auto;
    align-self: stretch;
    overflow-x: hidden;
}

.gui_vscode_PTgxj .gui_tab_QF0IR {
    width: 40px;
    height: 30px;
    flex-grow: 0;
    border-radius: 0px !important;
    margin: 0 !important;
    padding: 20px 0 !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0 !important;
    background-color: #00000000;
    border: 0;
}

.gui_vscode_PTgxj .gui_tab_QF0IR img {
    width: 1.35rem;
    height: 1.35rem;
    margin: 0 !important;
}

[dir="rtl"] .gui_vscode_PTgxj .gui_tab_QF0IR img {
    margin: 0 0 0.25rem 0 !important;
    transform: none;
}

.gui_vscode_PTgxj .gui_tab_QF0IR.gui_is-selected_UFsl5 {
    background-color: var(--ui-white);
    box-shadow: inset 3px 0px 0px 0px var(--looks-secondary)
}

/* 重置 RTL 下的镜像效果 */

.gui_vscode_PTgxj .gui_tab_QF0IR:nth-of-type(1) img,
.gui_vscode_PTgxj .gui_tab_QF0IR:nth-of-type(3) img {
    transform: none;
}

.gui_tab-panel_kc4gL {
    position: relative;
    flex-grow: 1;
    display: none;
}

.gui_tab-panel_kc4gL.gui_is-selected_UFsl5 {
    display: flex;
}

.gui_blocks-wrapper_ieUzD {
    flex-grow: 1;
    position: relative;
}

.gui_monaco-editor-wrapper_Vae8h {
    flex-grow: 1;
    position: relative;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.gui_stage-and-target-wrapper_QjvJN {
    /*
        Makes rows for children:
          1) stage menu
          2) stage
          3) sprite/stage selectors
        Only reason we need this, is so .targetWrapper, which holds the selectors,
        goes to full vertical height of the window
    */
    display: flex;
    flex-direction: column;
    min-height: 0;
    /* pad entire wrapper to the left and right; allow children to fill width */
    padding-left: 0 !important;
    padding-right: 0 !important;

    /* this will only ever be as wide as the stage */
    flex-basis: 0;
}

.gui_stage-and-target-wrapper_QjvJN.gui_hidden_CMlen {
    display: none;
}

.gui_target-wrapper_HJ42w {
    display: flex;
    flex-grow: 1;
    flex-basis: 0;

    padding-top: 0 !important;
    min-height: 0;
    /* this makes it work in Firefox */

    /*
        For making the sprite-selector a scrollable pane
        @todo: Not working in Safari
    */
    /* TODO this also breaks the thermometer menu */
    /* overflow: hidden; */
}

.gui_extension-button-container_KAf8J {
    width: 3.75rem;
    height: 3.25rem;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 42;
    background: var(--looks-secondary);

    border: 1px solid var(--looks-secondary);
    box-sizing: content-box;
    /* To match scratch-block vertical toolbox borders */
}

.gui_extension-button-container_KAf8J:before {
    content: "";
    position: absolute;
    top: calc(calc(-1 * 15px) - 1px);
    left: -1px;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15));
    height: 15px;
    width: calc(100% + 0.5px);
}

.gui_extension-button_V2B5K {
    background: none;
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.gui_extension-button-icon_pZL12 {
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 4px;
}

[dir="rtl"] .gui_extension-button-icon_pZL12 {
    transform: scaleX(-1);
}

.gui_extension-button_V2B5K>div {
    margin-top: 0;
}

/* Sprite Selection Watermark */

.gui_watermark_G_Q4G {
    position: absolute;
    top: 1.25rem;
    pointer-events: none;
}

[dir="ltr"] .gui_watermark_G_Q4G {
    right: 1.25rem;
}

[dir="rtl"] .gui_watermark_G_Q4G {
    left: 1.25rem;
}

/* Menu */

.gui_menu-bar-position_nzITJ {
    position: relative;
    z-index: 491;
    min-width: 1024px
        /*保证开插件时显示正确*/
}

/* Alerts */

.gui_alerts-container_kiiNN {
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 490;
    position: absolute;
    margin-top: 53px;
    pointer-events: none;
}

/*
    Make the (background) page not scrollable when modals are open
    This CSS class is automatically added to the body when react-modal is open
*/

.ReactModal__Body--open {
    overflow: hidden;
}

/* when in the browser's fullscreen mode, we need to put our own background to avoid just having black */

.gui_fullscreen-background_MULkR {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* overridden by JS; this will be used if the browser can't understand that color */
    background-color: white;
}

`, "",{"version":3,"sources":["webpack://./src/components/gui/gui.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;;IAEb;;;;KAIC;IACD,qCAAqC;IACrC,YAAY;;IAEZ;;;;KAIC;IACD,gBAAgB;AACpB;;AAEA;IACI;;;;;;;;;KASC;IACD,6DAA6D;IAC7D,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iCAAiC;;IAEjC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,qBAAqB;IACrB,cAAc;;IAEd,2DAA2D;IAC3D,gBAAgB;IAChB,kBAAkB;;IAElB,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;;IAE3B,0BAA0B;IAC1B,iEAAiE;IACjE,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;;IAEhB,4BAA4B;IAC5B,6CAA6C;;IAE7C,2BAA2B;IAC3B,kBAAkB;;IAElB,oCAAoC;IACpC,yCAAyC;;IAEzC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,yBAAyB;;OAEtB,sBAAsB;;QAErB,qBAAqB;;YAEjB,iBAAiB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,gDAAgD;;AAEhD;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,iCAAiC;IACjC,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sCAAsC;;AAEtC;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA,wCAAwC;;AAExC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA,kBAAkB;;AAElB;;IAEI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;;;;;;;KAOC;IACD,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,2EAA2E;IAC3E,0BAA0B;IAC1B,2BAA2B;;IAE3B,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;;IAEb,yBAAyB;IACzB,aAAa;IACb,kCAAkC;;IAElC;;;KAGC;IACD,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,kCAAkC;;IAElC,wCAAwC;IACxC,uBAAuB;IACvB,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,kEAAkE;IAClE,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,SAAS;;AAET;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;QACZ,aAAa;AACrB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;;CAGC;;AAED;IACI,gBAAgB;AACpB;;AAEA,wGAAwG;;AAExG;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mFAAmF;IACnF,uBAAuB;AAC3B","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.page-wrapper {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.body-wrapper {\n    flex-grow: 1;\n    background-color: var(--ui-primary);\n}\n\n.body-wrapper * {\n    box-sizing: border-box;\n}\n\n.flex-wrapper {\n    display: flex;\n\n    /*\n        Make 2 columns:\n        a) for the blocks + workspace panes, and\n        b) for combined stage menu + stage + sprite/stage selectors\n    */\n    /* flex-direction: row; Move to JSX */\n    height: 100%;\n\n    /*\n        Stop scrollbar popping in and out from scratch-blocks border issue\n        https://github.com/LLK/scratch-gui/issues/318\n        TW: and also fix double horizontal scrollbar at some screen sizes in paint editor\n    */\n    overflow: hidden;\n}\n\n.editor-wrapper {\n    /*\n        This is carefully balanced--  the minimum width at which the GUI will be displayed is 1024px.\n        At that size, the stage pane is 408px wide, with $space of padding to each side.\n        However, we must also add the border width to the stage pane. All-in-all, the stage pane's final width is\n        408px + ($space + $stage-standard-border-width * 2) (one border & padding per left/right side).\n\n        @todo This is in place to prevent \"doubling up\" of horizontal scrollbars in narrow windows, but there are likely\n        much better ways to solve that (e.g. undo #2124, remove this flex-basis entirely). However, they run their own\n        risks of breaking things, so let's just leave this as-is for the time being.\n    */\n    flex-basis: calc(1024px - 408px - ((0.5rem + 0.0625rem) * 2));\n    flex-grow: 1;\n    flex-shrink: 0;\n    position: relative;\n    background-color: var(--ui-white);\n\n    display: flex;\n    flex-direction: column;\n}\n\n.editor-wrapper-full {\n    flex-basis: auto !important;\n    flex-grow: 1 !important;\n    width: 100% !important;\n}\n\n.tab-list {\n    height: 2.75rem;\n    width: 250px;\n    /* Match width of the toolbox */\n    display: flex;\n    align-items: flex-end;\n    flex-shrink: 0;\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-weight: 500;\n    font-size: 0.80rem;\n\n    /* Overrides for react-tabs styling */\n    margin: 0 !important;\n    border-bottom: 0 !important;\n\n    color: var(--text-primary);\n    background-color: var(--editorDarkMode-page, hsl(215, 100%, 95%));\n    z-index: 25;\n}\n\n.tab {\n    flex-grow: 1;\n    height: 80%;\n    margin-bottom: 0;\n\n    border-radius: 1rem 1rem 0 0;\n    border: 1px solid var(--ui-black-transparent);\n\n    padding: 0.125rem 1.25rem 0;\n    font-size: 0.75rem;\n\n    background-color: var(--ui-tertiary);\n    color: var(--ui-text-primary-transparent);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    -webkit-user-select: none;\n\n       -moz-user-select: none;\n\n        -ms-user-select: none;\n\n            user-select: none;\n    white-space: nowrap;\n}\n\n[dir=\"ltr\"] .tab {\n    margin-left: -0.5rem;\n}\n\n[dir=\"rtl\"] .tab {\n    margin-right: -0.5rem;\n}\n\n[dir=\"ltr\"] .tab:nth-of-type(1) {\n    margin-left: 0;\n}\n\n[dir=\"rtl\"] .tab:nth-of-type(1) {\n    margin-right: 0;\n}\n\n/* Use z-indices to force left-on-top for tabs */\n\n.tab:nth-of-type(1) {\n    z-index: 3;\n}\n\n.tab:nth-of-type(2) {\n    z-index: 2;\n}\n\n.tab:nth-of-type(3) {\n    z-index: 1;\n}\n\n.tab:hover {\n    background-color: var(--ui-primary);\n}\n\n.tab.is-selected {\n    height: 90%;\n    color: var(--looks-secondary);\n    background-color: var(--ui-white);\n    z-index: 4;\n    /* Make sure selected is always above */\n}\n\n.tab img {\n    width: 1rem;\n    filter: grayscale(100%);\n}\n\n.tab:hover img {\n    filter: brightness(150%) grayscale(100%);\n    -webkit-filter: brightness(150%) grayscale(100%);\n}\n\n[dir=\"ltr\"] .tab img {\n    margin-right: 0.125rem;\n}\n\n[dir=\"rtl\"] .tab img {\n    margin-left: 0.125rem;\n}\n\n/* mirror blocks and sound tab icons */\n\n[dir=\"rtl\"] .tab:nth-of-type(1) img {\n    transform: scaleX(-1);\n}\n\n[dir=\"rtl\"] .tab:nth-of-type(3) img {\n    transform: scaleX(-1);\n}\n\n.tab.is-selected img {\n    filter: none;\n}\n\n/* Tab style overrides from react-tabs */\n\n.tab.is-selected:after {\n    display: none;\n}\n\n.tab.is-selected:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: var(--ui-black-transparent);\n}\n\n.tab.is-selected:focus:after {\n    display: none;\n}\n\n/* Body of the tabs */\n\n.tabs {\n    position: relative;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.vscode {\n    flex-direction: column !important;\n    height: 100% !important;\n}\n\n.vscodeList {\n    flex-direction: row !important;\n}\n\n.tab-list.vscode {\n    width: 41px;\n    flex-direction: column !important;\n    align-items: center;\n    justify-content: flex-start;\n    border-bottom: none;\n    overflow-y: auto;\n    align-self: stretch;\n    overflow-x: hidden;\n}\n\n.vscode .tab {\n    width: 40px;\n    height: 30px;\n    flex-grow: 0;\n    border-radius: 0px !important;\n    margin: 0 !important;\n    padding: 20px 0 !important;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-size: 0 !important;\n    background-color: #00000000;\n    border: 0;\n}\n\n.vscode .tab img {\n    width: 1.35rem;\n    height: 1.35rem;\n    margin: 0 !important;\n}\n\n[dir=\"rtl\"] .vscode .tab img {\n    margin: 0 0 0.25rem 0 !important;\n    transform: none;\n}\n\n.vscode .tab.is-selected {\n    background-color: var(--ui-white);\n    box-shadow: inset 3px 0px 0px 0px var(--looks-secondary)\n}\n\n/* 重置 RTL 下的镜像效果 */\n\n.vscode .tab:nth-of-type(1) img,\n.vscode .tab:nth-of-type(3) img {\n    transform: none;\n}\n\n.tab-panel {\n    position: relative;\n    flex-grow: 1;\n    display: none;\n}\n\n.tab-panel.is-selected {\n    display: flex;\n}\n\n.blocks-wrapper {\n    flex-grow: 1;\n    position: relative;\n}\n\n.monaco-editor-wrapper {\n    flex-grow: 1;\n    position: relative;\n    min-height: 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.stage-and-target-wrapper {\n    /*\n        Makes rows for children:\n          1) stage menu\n          2) stage\n          3) sprite/stage selectors\n        Only reason we need this, is so .targetWrapper, which holds the selectors,\n        goes to full vertical height of the window\n    */\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    /* pad entire wrapper to the left and right; allow children to fill width */\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n\n    /* this will only ever be as wide as the stage */\n    flex-basis: 0;\n}\n\n.stage-and-target-wrapper.hidden {\n    display: none;\n}\n\n.target-wrapper {\n    display: flex;\n    flex-grow: 1;\n    flex-basis: 0;\n\n    padding-top: 0 !important;\n    min-height: 0;\n    /* this makes it work in Firefox */\n\n    /*\n        For making the sprite-selector a scrollable pane\n        @todo: Not working in Safari\n    */\n    /* TODO this also breaks the thermometer menu */\n    /* overflow: hidden; */\n}\n\n.extension-button-container {\n    width: 3.75rem;\n    height: 3.25rem;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 42;\n    background: var(--looks-secondary);\n\n    border: 1px solid var(--looks-secondary);\n    box-sizing: content-box;\n    /* To match scratch-block vertical toolbox borders */\n}\n\n.extension-button-container:before {\n    content: \"\";\n    position: absolute;\n    top: calc(calc(-1 * 15px) - 1px);\n    left: -1px;\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15));\n    height: 15px;\n    width: calc(100% + 0.5px);\n}\n\n.extension-button {\n    background: none;\n    border: none;\n    outline: none;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.extension-button-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 4px;\n}\n\n[dir=\"rtl\"] .extension-button-icon {\n    transform: scaleX(-1);\n}\n\n.extension-button>div {\n    margin-top: 0;\n}\n\n/* Sprite Selection Watermark */\n\n.watermark {\n    position: absolute;\n    top: 1.25rem;\n    pointer-events: none;\n}\n\n[dir=\"ltr\"] .watermark {\n    right: 1.25rem;\n}\n\n[dir=\"rtl\"] .watermark {\n    left: 1.25rem;\n}\n\n/* Menu */\n\n.menu-bar-position {\n    position: relative;\n    z-index: 491;\n    min-width: 1024px\n        /*保证开插件时显示正确*/\n}\n\n/* Alerts */\n\n.alerts-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    z-index: 490;\n    position: absolute;\n    margin-top: 53px;\n    pointer-events: none;\n}\n\n/*\n    Make the (background) page not scrollable when modals are open\n    This CSS class is automatically added to the body when react-modal is open\n*/\n\n:global(.ReactModal__Body--open) {\n    overflow: hidden;\n}\n\n/* when in the browser's fullscreen mode, we need to put our own background to avoid just having black */\n\n.fullscreen-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    /* overridden by JS; this will be used if the browser can't understand that color */\n    background-color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-wrapper": `gui_page-wrapper_XhImG`,
	"pageWrapper": `gui_page-wrapper_XhImG`,
	"body-wrapper": `gui_body-wrapper_G5GJN`,
	"bodyWrapper": `gui_body-wrapper_G5GJN`,
	"flex-wrapper": `gui_flex-wrapper_zZPgR`,
	"flexWrapper": `gui_flex-wrapper_zZPgR`,
	"editor-wrapper": `gui_editor-wrapper_w4WEQ`,
	"editorWrapper": `gui_editor-wrapper_w4WEQ`,
	"editor-wrapper-full": `gui_editor-wrapper-full_xFN6I`,
	"editorWrapperFull": `gui_editor-wrapper-full_xFN6I`,
	"tab-list": `gui_tab-list_sIspJ`,
	"tabList": `gui_tab-list_sIspJ`,
	"tab": `gui_tab_QF0IR`,
	"is-selected": `gui_is-selected_UFsl5`,
	"isSelected": `gui_is-selected_UFsl5`,
	"tabs": `gui_tabs_af7tX`,
	"vscode": `gui_vscode_PTgxj`,
	"vscodeList": `gui_vscodeList_GM7MO`,
	"tab-panel": `gui_tab-panel_kc4gL`,
	"tabPanel": `gui_tab-panel_kc4gL`,
	"blocks-wrapper": `gui_blocks-wrapper_ieUzD`,
	"blocksWrapper": `gui_blocks-wrapper_ieUzD`,
	"monaco-editor-wrapper": `gui_monaco-editor-wrapper_Vae8h`,
	"monacoEditorWrapper": `gui_monaco-editor-wrapper_Vae8h`,
	"stage-and-target-wrapper": `gui_stage-and-target-wrapper_QjvJN`,
	"stageAndTargetWrapper": `gui_stage-and-target-wrapper_QjvJN`,
	"hidden": `gui_hidden_CMlen`,
	"target-wrapper": `gui_target-wrapper_HJ42w`,
	"targetWrapper": `gui_target-wrapper_HJ42w`,
	"extension-button-container": `gui_extension-button-container_KAf8J`,
	"extensionButtonContainer": `gui_extension-button-container_KAf8J`,
	"extension-button": `gui_extension-button_V2B5K`,
	"extensionButton": `gui_extension-button_V2B5K`,
	"extension-button-icon": `gui_extension-button-icon_pZL12`,
	"extensionButtonIcon": `gui_extension-button-icon_pZL12`,
	"watermark": `gui_watermark_G_Q4G`,
	"menu-bar-position": `gui_menu-bar-position_nzITJ`,
	"menuBarPosition": `gui_menu-bar-position_nzITJ`,
	"alerts-container": `gui_alerts-container_kiiNN`,
	"alertsContainer": `gui_alerts-container_kiiNN`,
	"fullscreen-background": `gui_fullscreen-background_MULkR`,
	"fullscreenBackground": `gui_fullscreen-background_MULkR`
};
export default ___CSS_LOADER_EXPORT___;
